<template>
  <card>
    <div class="box__title">
      (선택) 요청사항<span class="box__title--subtitle">중복선택 가능</span>
    </div>
    <div>
      <div
        class="comment"
        :class="{ comment__freight: getDeliveryOptions.vehicleItemCode === 2 }"
      >
        <div
          class="comment__checkbox"
          v-for="(comment, idx) in getDeliveryOptions.vehicleItemCode === 1
            ? commentList
            : freightCommentList"
        >
          <label class="checkbox">
            <input type="checkbox" v-model="comment.check" />
            <div class="checkbox__checkmark"></div>
            <div class="checkbox__label">
              {{ comment.title }}
            </div>
          </label>
          <img
            class="tooltip__img"
            v-if="idx === 0"
            src="@/assets/img/order/qmark.svg"
          />
          <div v-if="idx === 0" class="caution-tooltip">
            <img src="@/assets/img/order/ic_qmark_b.png" />
            <div>
              <div class="caution-tooltip__main">
                깨지기 쉬운 물품의 경우 포장 상태에 따라 배송이 불가할 수
                있습니다.
              </div>
            </div>
          </div>
        </div>
      </div>
      <input
        v-model="inputComment"
        @input="(inputComment = $event.target.value), mergedComments()"
        placeholder="직접 입력할 수 있어요"
      />
    </div>
    <div class="box__title applicant">
      (선택) 신청인 정보
      <span class="box__title--subtitle"
        >입력하신 연락처로 배송현황 알림톡을 받을 수 있어요
      </span>
    </div>
    <div class="alim-talk">
      <div class="input-cover">
        <input
          type="text"
          v-model="getDeliveryOptions.applicant.name"
          @input="updateApplicantName($event.target.value)"
          placeholder="이름/상호"
        />
        <img
          @click="updateApplicantName('')"
          src="@/assets/img/order/bi_x.svg"
        />
      </div>
      <div class="input-cover">
        <input
          type="number"
          v-model="getDeliveryOptions.applicant.phoneNumber"
          @input="updateApplicantPhoneNumber($event.target.value)"
          placeholder="연락처"
        />
        <img
          @click="updateApplicantPhoneNumber('')"
          src="@/assets/img/order/bi_x.svg"
        />
      </div>
    </div>
    <div class="applicant-memo">
      <textarea
        maxlength="80"
        placeholder="주문 메모하기 (최대 80자)"
        v-model="getDeliveryOptions.clientMemo"
        @input="updateClientMemo($event.target.value)"
      />
    </div>
  </card>
</template>
<script>
import card from "@/components/common/card.vue";
import mixinOrder from "@/mixins/mixinOrder";
export default {
  mixins: [mixinOrder],
  components: { card },
  watch: {
    commentList: {
      deep: true,
      handler() {
        this.mergedComments();
      }
    },
    freightCommentList: {
      deep: true,
      handler() {
        this.mergedComments();
      }
    },
    "getDeliveryOptions.vehicleItemCode": {
      handler() {
        this.resetCommentList();
      }
    }
  },

  data() {
    return {
      commentList: [
        { title: "깨지기 쉬워요", check: false },
        { title: "젖으면 안돼요", check: false },
        { title: "조심해 주세요", check: false },
        { title: "픽업/도착 전 연락주세요", check: false },
        { title: "부재시 문앞에 보관해 주세요", check: false }
      ],
      freightCommentList: [
        { title: "깨지기 쉬워요", check: false },
        { title: "카트/손수레 필요해요", check: false },
        { title: "픽업/도착 전 연락주세요", check: false },
        { title: "부재시 문앞에 보관해 주세요", check: false }
      ],
      inputComment: ""
    };
  },
  created() {
    this.getDefaultApplicantInfo();
    this.inputComment = this.getDeliveryOptions.clientComment;
  },
  methods: {
    resetCommentList() {
      this.commentList.map((comment) => {
        return { ...comment, check: false };
      });
      this.commentList.map((comment) => {
        return { ...comment, check: false };
      });
      this.inputComment = "";
    },
    mergedComments() {
      const list =
        this.getDeliveryOptions.vehicleItemCode === 2
          ? this.freightCommentList
          : this.commentList;
      const commentArray = list
        .filter((comment) => comment.check)
        .map((comment) => comment.title)
        .concat(this.inputComment);

      const commentString = commentArray
        .slice(0, commentArray.length - 1) // Exclude the last comment
        .join(" | "); // Add "|" between comments

      const finalComment =
        commentString +
        (commentArray.length > 1 ? " " : "") +
        commentArray[commentArray.length - 1];
      this.updateClientComment(finalComment);
    },

    /**
     * 신청인 정보 자동 입력
     */
    async getDefaultApplicantInfo() {
      try {
        const type = this.$store.getters["auth/tokenPayload"]().type;
        const result =
          this.$store.getters["auth/tokenPayload"]().type === "member"
            ? await this.$store.dispatch("users/biz_member_myInfo")
            : await this.$store.dispatch("users/biz_manager_myInfo");

        if (!result.success) return;
        this.updateApplicantPhoneNumber(result.information.phoneNumber);
        this.updateApplicantName(result.information.name);
      } catch (e) {
        await this.$store.dispatch("auth/signout");
        this.$router.push("/");
      }
    }
  }
};
</script>
<style src="./layout.css" scoped></style>
<style src="@/assets/css/newGlobal.css" scoped></style>
